import type { MermaidContent, MermaidDiagramType } from './schema.types';

/** Diagram types offered in the editor, with human labels. */
export const MERMAID_DIAGRAM_TYPES: { value: MermaidDiagramType; label: string }[] = [
  { value: 'flowchart-td', label: 'Vertical flowchart' },
  { value: 'flowchart-lr', label: 'Horizontal flowchart' },
  { value: 'mindmap', label: 'Mind map' },
  { value: 'timeline', label: 'Timeline' },
  { value: 'sequenceDiagram', label: 'Sequence diagram' },
];

/** The mermaid header (first line) each diagram type must start with. */
const HEADER: Record<MermaidDiagramType, string> = {
  'flowchart-td': 'flowchart TD',
  'flowchart-lr': 'flowchart LR',
  mindmap: 'mindmap',
  timeline: 'timeline',
  sequenceDiagram: 'sequenceDiagram',
};

const TEMPLATE: Record<MermaidDiagramType, string> = {
  'flowchart-td': `flowchart TD
  A[Topic] --> B[Point 1]
  A --> C[Point 2]
  A --> D[Point 3]`,
  'flowchart-lr': `flowchart LR
  A[Topic] --> B[Point 1]
  A --> C[Point 2]
  A --> D[Point 3]`,
  mindmap: `mindmap
  root((Topic))
    Point 1
    Point 2
    Point 3`,
  timeline: `timeline
  title Topic
  Step 1 : Point 1
  Step 2 : Point 2
  Step 3 : Point 3`,
  sequenceDiagram: `sequenceDiagram
  participant Teacher
  participant Student
  Teacher->>Student: Point 1
  Student->>Teacher: Point 2
  Teacher->>Student: Point 3`,
};

export const DEFAULT_MERMAID_SOURCE = TEMPLATE['flowchart-td'];

export function mermaidHeader(type: MermaidDiagramType): string {
  return HEADER[type];
}

const isFlowchart = (t: MermaidDiagramType): boolean =>
  t === 'flowchart-td' || t === 'flowchart-lr';


export function withDiagramType(source: string, type: MermaidDiagramType): string {
  const firstLine = (source.split('\n').find((l) => l.trim().length > 0) ?? '').trim();
  const sourceIsFlowchart = /^(flowchart|graph)\b/.test(firstLine);

  if (isFlowchart(type) && sourceIsFlowchart) {
    const lines = source.split('\n');
    const idx = lines.findIndex((l) => l.trim().length > 0);
    if (idx < 0) return HEADER[type];
    lines[idx] = HEADER[type];
    return lines.join('\n');
  }

  return TEMPLATE[type];
}

export function defaultMermaidContent(
  type: MermaidDiagramType = 'flowchart-td',
): MermaidContent {
  return { diagramType: type, source: TEMPLATE[type] };
}
